import {
  useState, useCallback, useMemo, useEffect, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

import clientsAction from '@state/client/actions';
import devicesApi from '@api/devicesApi';
import getColumnsAdmin from './columnsClientes';

function useClientes() {

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const abortController = useRef(null);

  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [sorter, setSorter] = useState(true);
  const [isSorter, setIsSorter] = useState(false);
  const [valueFilter, setValueFilter] = useState('');

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  abortController.current = new AbortController();
  const { signal } = abortController.current;

  const getAllclient = useMemo(() => () => {

    setLoading(true);
    const skip = 0;
    const limit = 1000;

    devicesApi.getAllClients({ signal, skip, limit })
        .then(async (response) => {

           const newClient = await Promise.all(response.map(async (obj) => {

            const devices_total = obj?.devices?.length;
            const business_type_name = obj?.business_type?.name;
            const item = { ...obj, business_type_name, devices_total };
            return item;

          }));

          setClients(newClient);

           setLoading(false);

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

  }, [setClients]);

  const createClient = useCallback( // Go to create /crear-dispositivo
  () => {

    history.push('/clientes/crear-cliente');

}, [history],
);

  const viewClient = useCallback((e) => {

    dispatch(clientsAction.setDashboardClient(false));
    history.push(`/clientes/${e.id}`);

}, []);

  const deleteClient = useCallback((e) => {

    const { id } = e;

    setLoading(true);
    devicesApi.deleteClientById({ signal, id })
      .then((response) => {

        setLoading(false);
        message.success(t('forms.clients.feedbacks.delete_success'));
        getAllclient();

      })
      .catch((error) => {

        setLoading(false);
        message.error(t('forms.clients.feedbacks.delete_failed'));

      });

}, [getAllclient, t]);

  const editClient = useCallback((e) => { // edit device, save data device in redux

    const {
      id, celsia_id,
      third_id,
      description,
      stratum,
      business_type_id,
      representative,
      devices,
    } = e;

    const defaultData = {
      celsia_id,
      third_id,
      description,
      stratum,
      business_type_id,
      representative,
      devices_id: devices.map((item) => item.id)[0] || '',
    };

    dispatch(clientsAction.setClientIdEdit(id));
    dispatch(clientsAction.setCreateEditClient(defaultData));

    history.push('/clientes/editar-cliente');

}, [dispatch, history]);

  const columns = useMemo(
    // eslint-disable-next-line
    () => getColumnsAdmin(t, currentUser, deleteClient, editClient, viewClient), [t, currentUser, deleteClient, editClient, viewClient],
);

  const arrayFilterAux = [];
    clients.forEach((value, index) => { // remove current user

    arrayFilterAux.push(value);

});

  const changeSort = () => {

      setIsSorter(true);
      if (sorter) {

        setClients([...clients].sort((a, b) => a.celsia_id.localeCompare(b.celsia_id)));

} else {

        setClients([...clients].sort((a, b) => b.celsia_id.localeCompare(a.celsia_id)));

}
      setSorter(!sorter);

};

  const arrayFilter = arrayFilterAux.filter((client) => (
    client && (
      client.description.toUpperCase().includes(valueFilter.toUpperCase())
      || (client.celsia_id && client.celsia_id.toUpperCase().includes(valueFilter.toUpperCase()))
      || (client.third_id && client.third_id.toUpperCase().includes(valueFilter.toUpperCase()))
    )
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  useEffect(() => { // componentDidMount

    getAllclient();

  }, [isCreate, history, getAllclient]);

  return {
    loading,
    sorter,
    isSorter,
    changeSort,
    columns,
    arrayFilter,
    isCreate,
    createClient,
    setValueFilter,
  };

}

export default useClientes;
